<div class="bina-catalog-fast-search-list">
  <div *ngFor="let item of resultItems; let index = index">
    <app-hts-code-card
      [favoriteHtsNumber]="item"
      [isCompact]="true"
      [isShowHoverBackground]="true"
      [isShowInsert]="true"
      [isShowCatalogSource]="true"
      [maxDescriptionLines]="2"
      [descriptionCharLimit]="108"
      (insert)="onHtsInsert(item)"
    ></app-hts-code-card>
    <hr class="bina-catalog-fast-search-list__item-seperation-line" *ngIf="index !== resultItems.length - 1 || isShowSuggestions" />
  </div>

  <ng-container *ngFor="let suggestion of visibleSuggestions; let index = index; trackBy: trackBySuggestion">
    <hr class="bina-catalog-fast-search-list__item-seperation-line" *ngIf="index > 0" />
    <app-hts-code-card
      [suggestion]="suggestion"
      [isCompact]="true"
      [isShowHoverBackground]="true"
      [isShowInsert]="true"
      [isShowSuggestionSource]="true"
      [maxDescriptionLines]="2"
      [descriptionCharLimit]="108"
      (insert)="onSuggestionInsert(suggestion)"
    ></app-hts-code-card>
  </ng-container>

  <button
    type="button"
    class="btn btn-link bina-catalog-fast-search-list__catalog-link"
    *ngIf="isShowCatalogLink"
    (click)="onFindInCatalog()"
  >
    {{ "BINA_CATALOG.SEARCH_ALL_SAVED" | translate }}
  </button>
</div>
